<template>
  <div class="container">
      <NavbarSimple :leftText="$t('common.task')"></NavbarSimple>
      <div class="wrapper">
          <div class="block0">
              <span>{{$t('taskPage.desc')}}</span>
          </div>
          <div class="block1">
              <div class="td">{{$t('taskPage.totalLimit')}}</div>
              <div class="td" style="color:#4169E1;" @click="showServiceEmail">{{$t('taskPage.contactService')}}>></div>
          </div>
      </div>
      <van-popup v-model="emailVisible" style="background-color: #d6b593">
        <div class="emailBox">
            E-mail: {{serviceEmail || 'n/a'}}
        </div>
    </van-popup>
  </div>
</template>

<script>
import NavbarSimple from '@/components/NavbarSimple.vue'
export default {
    name: 'task',
    components: {
        NavbarSimple,
    },
    data() {
        return {
            serviceEmail: '',
            emailVisible: false
        }
    },
    methods: {
        _fetch() {
            this.token = localStorage.getItem('token');
            this.apiV1({
                method: 'get',
                url: '/task',
                headers: {'Authorization': this.token}
            }).then(response => {
                const { success, data } = response.data;
                if (success) {
                    this.serviceEmail = data.serviceEmail;
                }
            })
        },
        showServiceEmail() {
            this._fetch();
            this.emailVisible = true;
        }
    }
}
</script>

<style scoped lang="less">
.wrapper {
    margin-top: 4rem;
    padding: 4rem;
    font-size: 3.467rem;
    color: #000;
    background-color: @app-theme-color4;
    border: 0.267rem solid @app-theme-color1;
    border-radius: 5.333rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    .block0 {
        width: 85rem;
        color: @app-theme-color1;
        .rate {
            color: @app-theme-color3;
        }
    }
    .block1, .block2 {
        margin-top: 5.333rem;
        background-color: #d6b593;
        border: 0.267rem solid #814000;
        color: #814000;
        border-radius: 4rem;
        padding: 3.888rem;
        width: 85rem;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .td {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 50%;
            height: 8rem;
            border-radius: 0.8rem;
        }
    }
}
.emailBox {
    font-size: 16px;
    padding: 6rem 8rem;
}
</style>